// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide_slide__2bgCX","slideWrapper":"slide_slideWrapper__3_SA2","slideMover":"slide_slideMover__3-xi3","slideNav":"slide_slideNav__1GMKh"};